<template>
  <div class="privacy">
    <h1>Privacy Policy - {{ siteData.legalName }}</h1>
    <p>La privacy è importante, {{ siteData.legalName }} si impegna a proteggere i dati personali di tutti i suoi clienti.</p>
    <p>Compilando il seguente modulo potrai richiedere la verifica dei tuoi dati e/o dare seguito alla loro rimozione dai sistemi informativi di {{ siteData.legalName }}. L’azienda si riserva 30gg. lavorativi per l’attuazione.</p>
  </div>
</template>

<script>
import asyncLoading from './mixins/asyncLoading'
import localeHandler from './mixins/localeHandler'

export default {
  name: 'Privacy',
  mixins: [ asyncLoading, localeHandler ]
}
</script>

<style lang="scss">

</style>
